<div class="banner" *ngIf="messageInfo.isVisible">
  <cobalt-banner
    [kind]="messageInfo.kind"
    [hasClose]="true"
    (closeClicked)="closeMessage()"
  >
    <ng-container banner-message>
      <span class="content">{{ messageInfo.message }}</span>
      <span *ngIf="!messageInfo.hideSuffix" class="suffix">
        If this error persists,
      </span>
      <a
        *ngIf="!messageInfo.hideContactUs"
        [tabIndex]="1"
        cobaltLink
        variant="inline"
        class="banner-link"
        (click)="showHelp()"
        aria-label="Contact us"
        >contact us.</a
      >
    </ng-container>
  </cobalt-banner>
</div>
